import React, { useEffect } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { TextMD } from 'styleguide/Texts';
import { UserCell } from './components/UserCell';
import { colors } from 'styleguide/colors';
import { Spacing } from 'styleguide/spacing';
import { SuggestedAthletesViewModel } from './SuggestedAthletesViewModel';
import { Card } from 'styleguide/Card';

const Container = styled(Card)`
  display: flex;
  flex-direction: column;
  padding: ${Spacing.lg}px;
  gap: ${Spacing.md}px;
  max-height: calc(100vh - 480px);
  overflow-y: auto;
`;

const LoadingContainer = styled.div`
  display: flex;
  padding-top: ${Spacing.md}px;
  align-items: center;
  justify-content: center;
`;

const vm = new SuggestedAthletesViewModel();

export const SuggestedAthletes = () => {
  useEffect(() => {
    vm.onMounted();
  }, []);

  return <SuggestedAthletesInner vm={vm} />;
};

interface SuggestedAthletesInnerProps {
  vm: SuggestedAthletesViewModel;
}

export const SuggestedAthletesInner = observer(({ vm }: SuggestedAthletesInnerProps) => {
  return (
    <Container>
      {vm.cells.map(c => {
        switch (c.type) {
          case 'header':
            return <TextMD key={c.title}>{c.title}</TextMD>;
          case 'user':
            return <UserCell key={c.username} {...c} />;
          case 'loading':
            return (
              <LoadingContainer key={'loading'}>
                <ClipLoader size={30} color={colors.primary500} loading={true} />
              </LoadingContainer>
            );
        }
      })}
    </Container>
  );
});
